import styled from '@emotion/styled';
import css from '@emotion/css';
import { isScoreBeta } from '../utils/beta';

interface IButton {
  styleType?: string;
}

const Button = styled.button<IButton>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 21px 0;
  text-align: center;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.27;
  border-radius: 7px;
  border: 2px solid transparent;
  outline: 0;
  cursor: pointer;

  @media screen and (max-width: 500px) {
    padding: 16px 0;
  }

  /* 새 디자인 (2026-10): 둥근 버튼, 주 버튼은 호박색 */
  ${() =>
    isScoreBeta() &&
    css`
      border-radius: 14px;
      font-weight: 700;
    `}
  ${({ styleType }) =>
    isScoreBeta() &&
    styleType === 'blue' &&
    css`
      background-color: #ffb547 !important;
      color: #0d0e12 !important;
    `}
  ${({ styleType }) =>
    isScoreBeta() &&
    styleType === 'outline' &&
    css`
      border-color: #3a3f4b !important;
      color: #e9ebf0 !important;
      background: transparent !important;
    `}
  ${({ styleType }) =>
    isScoreBeta() &&
    styleType === 'disabled' &&
    css`
      background-color: #2a2e38 !important;
      color: #7c8392 !important;
    `}

  ${({ styleType }) =>
    styleType === 'blue' &&
    css`
      background-color: #295396;
      color: white;
    `}
  ${({ styleType }) =>
    styleType === 'disabled' &&
    css`
      background-color: #8f8f8f;
      color: white;
    `}

  ${({ styleType }) =>
    styleType === 'outline' &&
    css`
      background-color: transparent;
      border-color: #295396;
      color: #295396;
      html[color-mode='dark'] & {
        color: white;
      }
    `}
    ${({ styleType }) =>
    styleType === 'kakao' &&
    css`
        background-color: #f9e816;
        html[color-mode='dark'] & {
          color: #f9e816;
          background: transparent;
          border: solid 1px #f9e816;
        }
      `}
    ${({ styleType }) =>
    styleType === 'apple' &&
    css`
        margin-top:10px;
        background-color: #ffffff;
        html[color-mode='dark'] & {
          color: #ffffff;
          background: transparent;
          border: solid 1px #ffffff;
        }
      `}
    ${({ styleType }) =>
    styleType === 'google' &&
    css`
        margin-top:10px;
        background-color: rgb(213, 20, 20);
        html[color-mode='dark'] & {
          color: rgb(213, 20, 20);
          background: transparent;
          border: solid 1px rgb(213, 20, 20);
        }
      `}
`;

export default Button;
